// Display decimals
export const displayTwoDecimals = num => parseFloat(num).toFixed(2);
export const displaySatoshiDecimals = num => parseFloat(num).toFixed(8);
